<template>
  <div class="w-full mt-12 text-2xl text-gray-400  flex flex-col justify-start items-start bg-purlple-100  ">
    <div
      v-if="currentItem != undefined"
      class="w-full mb-6 flex flex-col items-start justify-start w-full"
    >
      <label class="text-left block mb-2 text-sm font-bold text-gray-900 ">
        Texte a afficher </label>
      <div class="flex flex-row justify-start items-center w-full">
        <textarea
          v-model="data"
          type="text"
          class="h-36 w-full border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
          required
        />
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'DeveloperCellText',
        components: {

        },
        props: {
            item: Object
        },

        data() {
            return ({
                lg: "FR",
                data: "",
                currentItem: {},

            })
        },
        computed: {

        },
        watch: {
            item: function (val) {
                let item = val;
                this.data = item.data


                this.currentItem = item;

            }
        },
        mounted() {
            let item = this.item;
            this.data = item.data

            this.currentItem = item;
        },

        methods: {

        }

    }
</script>